import http from 'conversations-http/clients/http';
import { TICKET_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';

// eslint-disable-next-line conversations/no-private-internals-import

const DEFAULT_LIMIT = 100;
export const fetchSearchViewMembersService = ({
  filterGroups,
  inboxId,
  limit = DEFAULT_LIMIT,
  offsetTimestamp,
  offsetId,
  primaryOffsetValue,
  secondaryOffsetValue,
  searchQuery,
  sortDirection = 'DESC',
  sortProperty
}) => {
  return http.post('/conversations-custom-views/v1/members/helpdesk/search', {
    data: {
      filterGroups,
      inboxId,
      limit,
      objectTypeId: TICKET_TYPE_ID,
      offsetTimestamp,
      offsetId,
      primaryOffsetValue,
      secondaryOffsetValue,
      maxPreviewLength: 200,
      searchQuery,
      sortDirection,
      userRequestedSortProperty: sortProperty,
      includeHiddenFromVisitor: true
    }
  });
};